import React from 'react'
import pageNotFound from '../../assest/img/error-404.jpg'
import { Link } from 'react-router-dom'

export default function PageNotFound() {
    return (
        <div>
            <div style={{ display: "flex", justifyContent: "center" }}>
                <Link to='/' className='btn btn-primary' style={{ position: "absolute", marginTop: "425px", padding: "20px", borderRadius: "30px" }}>Go To Home Page</Link>
            </div>
            <div>
                <img src={pageNotFound} alt='Erorr' width="100%" />
            </div>
        </div>
    )
}
